import LinkSearch from "./LinkSearch";
export default LinkSearch;
